export enum BillType{void ,complementary,payable};